module.exports = __webpack_public_path__ + "img/ecology-action.593a89ae.webp";